import { render, staticRenderFns } from "./TqNotificationContainer.vue?vue&type=template&id=5ac20106&scoped=true&"
import script from "./TqNotificationContainer.vue?vue&type=script&lang=js&"
export * from "./TqNotificationContainer.vue?vue&type=script&lang=js&"
import style0 from "./TqNotificationContainer.vue?vue&type=style&index=0&id=5ac20106&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac20106",
  null
  
)

export default component.exports